import { Component, Element, Listen, Prop, forceUpdate, h } from '@stencil/core';
import { generateCssClasses } from '../../../utils/generate-css-classes';
import { isTablet } from '../../../utils/responsive';

@Component({
	shadow: true,
	styleUrl: 'zds-navigation-logo.scss',
	tag: 'zds-navigation-logo',
})
export class ZdsNavigationLogo {
	@Element() hostElement: HTMLDivElement;

	@Prop() alt?: string = 'Logo';
	@Prop() link?: string = 'https://www.zig.nl';
	@Prop() mobileWidth?: number;
	@Prop() src: string = '';
	@Prop() width?: number = 100;
	@Prop() overlap?: boolean = false;
	@Prop() overlapBehaviour?: 'full' | 'main-bar-only' = 'full';
	@Prop() overlapMobile?: boolean = false;
	@Prop() position?: 'default' | 'top-left' = 'default';

	@Listen('resize', { target: 'window' })
	onDocumentResize() {
		forceUpdate(this.hostElement);
	}

	getWidthCss() {
		if (isTablet()) {
			if (this.mobileWidth !== undefined) return this.mobileWidth + 'px';
			return undefined;
		}
		return this.width + 'px';
	}

	render() {
		const cssClasses = generateCssClasses('zds-navigation-logo', {
			overlap: this.overlap,
			overlapMobile: this.overlapMobile,
			[`overlap-behaviour-${this.overlapBehaviour}`]: true,
			[`position-${this.position}`]: true,
			hasMobileWidth: !!this.mobileWidth,
		});

		const logoStyle = {
			width: this.getWidthCss(),
		};

		return (
			<div class={cssClasses} style={logoStyle}>
				<div class="zds-navigation-logo__wrapper">
					<a class="zds-navigation-logo__link" href={this.link}>
						<img class="zds-navigation-logo__img" alt={this.alt} src={this.src ? this.src : '/'} />
					</a>
				</div>
			</div>
		);
	}
}
